import Badge from 'components/shared/Badge/Badge';
import Disclosure from 'components/shared/Disclosure/Disclosure';
import Typography from 'components/shared/Typography/Typography';

const authorizationAppliedOptions = [
  {
    title: 'All visits this year',
    value: 'all-visits-this-year',
    recommended: true
  },
  {
    title: 'This visit',
    value: 'this-visit',
    recommended: false
  },
  {
    title: 'Let the patient choose',
    caption:
      'Patient selects "this visit only" or "all visits" on the Pre-Authorized Healthcare form.',
    value: 'let-patient-choose',
    recommended: false
  }
];

const AuthorizationApplied = ({ value, onChange }) => {
  return (
    <div className="flex flex-col gap-1.5">
      <Typography variant="p" size="small">
        Authorization applied to
      </Typography>
      {authorizationAppliedOptions.map((option) => {
        const isActive = option.value === value;
        return (
          <Disclosure
            key={option.value}
            isOpen={isActive}
            onToggle={() => onChange(option.value)}
            customTitle={
              <div className="flex gap-2">
                <Typography variant="p" size="small" weight="medium">
                  {option.title}
                </Typography>
                {option.recommended && (
                  <Badge text="Recommended" variant="lighter" color="primary" size="small" />
                )}
              </div>
            }
            disableOpen
            caption={option.caption}
            className="w-full"
            buttonClassName="py-2"
            bodyClassName="flex-col gap-0"
            radio
          />
        );
      })}
    </div>
  );
};

export default AuthorizationApplied;
